import React, { useState, useEffect, useRef } from "react";
import { BackButton, InputWithLabel } from "../../../components/micro";
import { headChat } from "../../../assets/image";
import { BusinessBuilding, HouseSearch } from "../../../assets/svg/AllSvg";
import ReactSelect from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { getCountryData } from "../../../redux/address/slice";
import { useLocation, useNavigate } from "react-router-dom";
import { createServicesRequest } from "../../../redux/serviceRequest/slice";

const RegisteredAddress = () => {
  return (
    <div className="flex space-x-5">
      <HouseSearch />
      <div>
        <span className="px-2.5 py-1 text-sm bg-lightGreen text-white inline-block rounded-full mb-2">
          Your SGCorpHub Registered Address
        </span>
        <p className="text-2xl font-ebGaramond mb-2">
          Your Registered Office Address
        </p>
        <div className="text-gray-400">
          {/* <p className="text-sm">Address Line 1:</p> */}
          <p>Blk 123 Walk the Lane #01-11</p>
          {/* <p className="text-sm">Address Line 2:</p> */}
          {/* <p className="text-sm">Postal Code:</p> */}
          <p>123456</p>
          {/* <p className="text-sm">Country:</p> */}
          <p>Singapore</p>
        </div>
      </div>
    </div>
  );
};

const NewRegisteredOfficeAddress = ({
  formValues,
  setFormValues,
  onFormComplete,
}) => {
  const dispatch = useDispatch();
  const [countryArray, setCountryArray] = useState([]);

  const { countryData, countryLoading } = useSelector((store) => ({
    countryData: store?.addressData?.getCountryDataStatus?.data,
    countryLoading: store?.addressData?.getCountryDataStatus?.loading,
  }));

  useEffect(() => {
    dispatch(getCountryData());
  }, [dispatch]);

  useEffect(() => {
    if (countryData?.data) {
      const data = countryData?.data?.map((x) => ({
        ...x,
        label: `+ ${x?.phone_code} (${x?.name})`,
      }));
      setCountryArray(data);
    }
  }, [countryData]);

  useEffect(() => {
    onFormComplete(
      formValues.address_type &&
        formValues.address_line_1 &&
        formValues.address_line_2 &&
        formValues.postal_code &&
        formValues.country
    );
  }, [formValues, onFormComplete]);

  const handleInputChange = (e) => {
    setFormValues((prev) => ({
      ...prev,
      [e.target.id]: e.target.value,
    }));
  };

  const handleSelectChange = (selectedOption) => {
    setFormValues((prev) => ({
      ...prev,
      country: selectedOption,
    }));
  };
  const handleSelectAddressChange = (selectedOption) => {
    setFormValues((prev) => ({
      ...prev,
      address_type: selectedOption,
    }));
  };

  return (
    <div className="space-y-3 border-b border-secondary_grey pb-3">
      <p>New Registered Office Address</p>
      <ReactSelect
        className={"p-0"}
        id="address_type"
        placeholder="Address Type"
        onChange={handleSelectAddressChange}
        options={[
          { value: "home", label: "Home" },
          { value: "office", label: "Office" },
        ]}
        isLoading={false}
        styles={{
          control: (base) => ({
            ...base,
            border: `1px solid #cdddeb`,
            borderRadius: "0.3rem",
            paddingTop: "4px",
            paddingBottom: "4px",
            boxShadow: "none",
            "&:hover": {
              border: "1px solid #cdddeb",
            },
          }),
        }}
      />
      <InputWithLabel
        label={"Address Line 1"}
        type={"text"}
        id={"address_line_1"}
        value={formValues.address_line_1}
        onChange={handleInputChange}
        className={"border"}
      />
      <InputWithLabel
        label={"Address Line 2"}
        type={"text"}
        id={"address_line_2"}
        value={formValues.address_line_2}
        onChange={handleInputChange}
        className={"border"}
      />
      <div className="grid grid-cols-2 gap-5">
        <InputWithLabel
          label={"Postal Code"}
          type={"text"}
          id={"postal_code"}
          max={6}
          value={formValues.postal_code}
          onChange={handleInputChange}
          className={"border"}
        />
        <ReactSelect
          className={"p-0"}
          id="Country"
          placeholder="Country"
          options={countryArray}
          value={formValues.country}
          onChange={handleSelectChange}
          isLoading={countryLoading}
          getOptionValue={(option) => option.name}
          styles={{
            control: (base) => ({
              ...base,
              border: `1px solid #cdddeb`,
              borderRadius: "0.3rem",
              paddingTop: "4px",
              paddingBottom: "4px",
              boxShadow: "none",
              "&:hover": {
                border: "1px solid #cdddeb",
              },
            }),
          }}
        />
      </div>
    </div>
  );
};

const ChangeCompanyAddress = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [isFormComplete, setIsFormComplete] = useState(false);
  const [formValues, setFormValues] = useState({
    address_type: "",
    address_line_1: "",
    address_line_2: "",
    postal_code: "",
    country: null,
  });
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const user_id = location?.state?.user_id;
  const company_id = location?.state?.company_id;
  const service = location?.state?.service;
  const buttonRef = useRef(null);

  const createServicesRequestData = useSelector(
    (store) => store?.serviceRequestData?.createServicesRequestStatus?.data
  );
  const createServicesRequestLoading = useSelector(
    (store) => store?.serviceRequestData?.loading
  );

  // Proceed with request
  const handleProceed = () => {
    const payload = {
      details:
        activeTab === 0
          ? []
          : {
              address_line_1: formValues.address_line_1,
              address_line_2: formValues.address_line_2,
              country: formValues.country.id,
              postal_code: formValues.postal_code,
              address_type: formValues.address_type.value,
            },
      amount:
        service?.service_requests_count < service?.detail?.no_of_free_request
          ? 0
          : service?.detail?.price,
      user_id: user_id,
      company_id: company_id,
      service_id: service?.id,
    };
    dispatch(createServicesRequest(payload)).then((res) => {
      if (res.type !== "createServicesRequest/fulfilled") return;
      const { service_requests_count, detail } = service || {};
      const price = detail?.price || 0;
      if (
        service_requests_count < service?.detail?.no_of_free_request ||
        price <= 0
      ) {
        navigate("/approver");
      } else if (buttonRef.current) {
        buttonRef.current.click();
      } else {
        navigate("/approver");
      }
    });
  };

  const tabs = [
    {
      text: "Use SGCorpHub’s registered address & Digital Mailroom Service",
      id: 0,
      content: <RegisteredAddress />,
      price: service?.detail?.price,
    },
    {
      text: "Use your own company address",
      link: "Eligibility Criteria",
      id: 1,
      content: (
        <NewRegisteredOfficeAddress
          setFormValues={setFormValues}
          formValues={formValues}
          onFormComplete={setIsFormComplete}
        />
      ),
    },
  ];

  return (
    <div className="space-y-5">
      <BackButton onClick={() => navigate("/service")} />
      <div className="flex items-center space-x-5 border-b-2 border-secondary_grey pb-7">
        <img src={headChat} alt="img" />
        <div className="space-y-2 font-ebGaramond">
          <p className="text-xl">We see that you will need a request on:</p>
          <p className="text-3xl">Change of Company Address</p>
        </div>
      </div>
      <div className="space-y-3 border-b border-secondary_grey pb-3">
        <p className="text-2xl font-ebGaramond">
          Let us guide you through the process:
        </p>
        <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
          <span>1.</span>
          <p>Tell us about your new company address</p>
        </div>
        {/* Payment Button */}
        <a
          className="hidden"
          ref={buttonRef}
          href={createServicesRequestData?.data?.url}
        >
          Pay Now
        </a>
        {activeTab === 1 && (
          <div className="flex space-x-5">
            <HouseSearch />
            <div>
              <p className="text-2xl font-ebGaramond mb-2">
                Your Registered Office Address
              </p>
              <div className="text-gray-400">
                {/* <p className="text-sm">Address Line 1:</p> */}
                <p>Blk 123 Walk the Lane #01-11</p>
                {/* <p className="text-sm">Address Line 2:</p> */}
                {/* <p className="text-sm">Postal Code:</p> */}
                <p>123456</p>
                {/* <p className="text-sm">Country:</p> */}
                <p>Singapore</p>
              </div>
            </div>
          </div>
        )}
        {/* tab head */}
        <div className="grid grid-cols-2 gap-5">
          {tabs.map((element) => (
            <div
              key={element.id}
              className={`p-4 ${
                activeTab === element.id
                  ? "bg-light_primary_shades"
                  : "bg-white"
              } rounded-lg border-2 space-y-3`}
              onClick={() => setActiveTab(element.id)}
            >
              <div className="flex space-x-5">
                <BusinessBuilding />
                <div className="space-y-3 w-full">
                  <p>{element.text}</p>
                  {element.price && (
                    <div className="flex justify-between space-x-1 bg-light_primary_shades px-4 py-3">
                      <p>Price</p>
                      <div>
                        <p className="text-sm text-gray-400">Annual Fees</p>
                        <p>${service?.detail?.price}</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {element.link && (
                <button className="text-theme border-b border-theme">
                  {element.link}
                </button>
              )}
            </div>
          ))}
        </div>
        {/* tab content */}
        {tabs.map((element) => activeTab === element.id && element.content)}
        <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
          <span>2.</span>
          <p>We will prepare the relevant resolution</p>
        </div>
        <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
          <span>3.</span>
          <p>Obtain signed resolution</p>
        </div>
        <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
          <span>4.</span>
          <p>
            We will lodge the changes to ACRA for the change of Company Name
          </p>
        </div>
        <p className="text-sm">
          Once the request is opened, you can easily manage it over at the
          “On-Going” service page.
        </p>
      </div>
      <div className="flex items-center justify-between space-x-1 bg-light_primary_shades rounded-lg px-4 py-3">
        <p className="font-semibold">Total Payable:</p>
        <div>
          <p className="text-xs">
            {service?.service_requests_count}/
            {service?.detail?.no_of_free_request ?? 0} used
          </p>
          {service?.service_requests_count >=
          service?.detail?.no_of_free_request
            ? `$${service?.detail?.price}`
            : "Free"}
        </div>
      </div>
      <div className="box !rounded-xl flex items-center justify-between">
        <button
          className={`uppercase ${
            (!isFormComplete && activeTab === 1) || createServicesRequestLoading
              ? "btn-outline-disabled"
              : "btn-theme"
          }`}
          onClick={handleProceed}
          disabled={
            (!isFormComplete && activeTab === 1) || createServicesRequestLoading
          }
        >
          {createServicesRequestLoading ? "Loading..." : "Proceed with request"}
        </button>
        <div>
          <p className="text-xs">Total:</p>
          {service?.service_requests_count >=
          service?.detail?.no_of_free_request
            ? `$${service?.detail?.price}`
            : "Free"}
        </div>
      </div>
    </div>
  );
};

export default ChangeCompanyAddress;
